import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { SetupParticipantEventJourney } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'
import { COLORS } from 'constants/layout/section-colors'

export default class SetupParticipantEventJourneyModal extends Component {
  static propTypes = {
    colorClass: PropTypes.string,
    modalId: PropTypes.string,
    title: PropTypes.object
  }

  static defaultProps = {
    colorClass: COLORS.green.value
  }

  render() {
    const { colorClass, modalId, title } = this.props

    return (
      <MaterialModal.Body id={modalId} colorClass={colorClass} title={title}>
        <MaterialModal.Content>
          <SetupParticipantEventJourney {...this.props} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
